import Vue from 'vue';
import {
  Circle,
  Button,
  Cell,
  CellGroup,
  Icon,
  Image as VanImage,
  Col, Row,
  Popup,
  Toast,
  Lazyload,
  List,
  Step,
  Steps,
  Swipe,
  SwipeItem,
  Tag,
  Empty,
  Divider,
  Grid,
  GridItem,
  NavBar,
  PullRefresh,
  Card,
  Switch,
  Panel,
  Dialog,
  Checkbox,
  CheckboxGroup,
  Form,
  Field,
  Rate,
  Search,
  Tab,
  Tabs,
  RadioGroup,
  Radio,
  Stepper,
  Skeleton,
  ImagePreview,
  ActionSheet 
} from 'vant';
Vue.use(Circle);
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(VanImage);
Vue.use(Col);
Vue.use(Row);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(List);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tag);
Vue.use(Empty);
Vue.use(Divider);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(NavBar);
Vue.use(PullRefresh);
Vue.use(Card);
Vue.use(Switch);
Vue.use(Panel);
Vue.use(Dialog);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Form);
Vue.use(Field);
Vue.use(Rate);
Vue.use(Search);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Stepper);
Vue.use(Skeleton)
Vue.use(ImagePreview)
Vue.use(ActionSheet)